<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Person_User_People_-_Add"
      data-name="Icon/Person User People - Add"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="13.619"
      viewBox="0 0 14.376 13.619"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Person-add"
        data-name="Icon/Icon/Person-add"
        d="M9.836,13.619a.757.757,0,0,1-.757-.756,3.783,3.783,0,1,0-7.566,0,.756.756,0,0,1-1.513,0,5.3,5.3,0,0,1,10.593,0A.757.757,0,0,1,9.836,13.619ZM5.3,6.053A3.027,3.027,0,1,1,8.323,3.027,3.03,3.03,0,0,1,5.3,6.053Zm0-4.54A1.513,1.513,0,1,0,6.809,3.027,1.516,1.516,0,0,0,5.3,1.513ZM12.106,5.3a.758.758,0,0,1-.757-.757V3.783h-.756a.756.756,0,1,1,0-1.513h.756V1.513a.757.757,0,0,1,1.514,0V2.27h.756a.756.756,0,1,1,0,1.513h-.756V4.54A.758.758,0,0,1,12.106,5.3Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AddUserIcon extends Vue {}
</script>

<style>
</style>
